export function phone(phoneNumber: string) {
  const phone = phoneNumber.replace(/\D/g, '');
  if (phone.length !== 11) {
    return false;
  }
  if (phone[2] !== '9') {
    return false;
  }
  return true;
}

export function email(value: string) {
  return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(value);
}

export function required(value: string) {
  return !!value;
}

export function atLeast(value: string, limit: number) {
  return value.length >= limit;
}

export function oneLetter(value: string) {
  return /[a-zA-Z]/.test(value);
}

export function oneSpecialCharacter(value: string) {
  return /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(value);
}

export function oneNumber(value: string) {
  return /[0-9]/.test(value);
}

export function minLength(value: string, length: number) {
  return value.length >= length;
}

export function nonZero(value: string | number) {
  return +value !== 0;
}
